// IoTable.jsx - IO设备遥测数据表
import React from 'react';
import { Table, Tag } from 'antd';
import { useTranslation } from '../../../../utils/useI18n';

const COLORS = { primary: '#00d4ff', muted: 'rgba(255,255,255,0.6)' };
const fmtTime = t => t ? new Date(t).toLocaleString() : '-';

const IoTable = ({ data }) => {
  const { t } = useTranslation();

  const columns = [
    { title: 'SN', dataIndex: 'sn', key: 'sn', width: 100, render: v => <span style={{ color: COLORS.primary }}>{v || '-'}</span> },
    { title: t('cloud.online'), dataIndex: 'online', key: 'online', width: 70, render: v => v === 1 ? <span style={{ color: '#52c41a' }}>●</span> : <span style={{ color: '#999' }}>○</span> },
    { title: t('cloud.state'), dataIndex: 'state', key: 'state', width: 100, render: v => v || '-' },
    { title: t('cloud.globalNo'), dataIndex: 'global_no', key: 'global_no', width: 120, render: v => v || '-' },
    { title: t('cloud.deviceType'), dataIndex: 'device_type', key: 'device_type', width: 100, render: v => v || '-' },
    { title: t('cloud.deviceRole'), dataIndex: 'device_role', key: 'device_role', width: 110, render: v => v || '-' },
    { title: t('cloud.parentGlobalNo'), dataIndex: 'parent_global_no', key: 'parent_global_no', width: 130, render: v => v || '-' },
    { title: t('cloud.recordedAt'), dataIndex: 'recorded_at', key: 'recorded_at', width: 160, render: fmtTime },
  ];

  const expandedRowRender = (record) => {
    const dio = record.data_json || {};
    const keys = Object.keys(dio).sort();

    if (keys.length === 0) return <span style={{ color: COLORS.muted }}>无IO数据</span>;

    // DI (数字输入) 和 DO (数字输出)
    const diKeys = keys.filter(k => k.toUpperCase().startsWith('DI'));
    const doKeys = keys.filter(k => k.toUpperCase().startsWith('DO'));
    const otherKeys = keys.filter(k => !k.toUpperCase().startsWith('DI') && !k.toUpperCase().startsWith('DO'));

    const renderTag = (key, val) => {
      const isActive = val === 1 || val === true || val === '1';
      const isDI = key.toUpperCase().startsWith('DI');
      const color = isActive ? (isDI ? '#52c41a' : '#1677ff') : '#888';
      const label = isActive ? 'ON' : 'OFF';
      return (
        <div key={key} style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', minWidth: 50, padding: '4px 8px', background: 'rgba(255,255,255,0.05)', borderRadius: 4, border: `1px solid ${color}40` }}>
          <span style={{ fontSize: 11, color: COLORS.muted }}>{key}</span>
          <Tag style={{ backgroundColor: isActive ? color : 'transparent', borderColor: color, color: isActive ? '#fff' : color, margin: 0, fontSize: 12, fontWeight: 'bold' }}>{label}</Tag>
        </div>
      );
    };

    return (
      <div style={{ padding: '8px 0' }}>
        {diKeys.length > 0 && (
          <div style={{ marginBottom: 12 }}>
            <div style={{ color: COLORS.muted, fontSize: 12, marginBottom: 8 }}>
              {t('cloud.digitalInput') || '数字输入 (DI)'} ({diKeys.length})
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {diKeys.map(k => renderTag(k, dio[k]))}
            </div>
          </div>
        )}
        {doKeys.length > 0 && (
          <div style={{ marginBottom: otherKeys.length > 0 ? 12 : 0 }}>
            <div style={{ color: COLORS.muted, fontSize: 12, marginBottom: 8 }}>
              {t('cloud.digitalOutput') || '数字输出 (DO)'} ({doKeys.length})
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {doKeys.map(k => renderTag(k, dio[k]))}
            </div>
          </div>
        )}
        {otherKeys.length > 0 && (
          <div>
            <div style={{ color: COLORS.muted, fontSize: 12, marginBottom: 8 }}>
              {t('cloud.otherPoints') || '其他点位'} ({otherKeys.length})
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {otherKeys.map(k => (
                <div key={k} style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', minWidth: 50, padding: '4px 8px', background: 'rgba(255,255,255,0.05)', borderRadius: 4 }}>
                  <span style={{ fontSize: 11, color: COLORS.muted }}>{k}</span>
                  <span style={{ color: '#fff', fontSize: 12 }}>{String(dio[k])}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  if (!data || data.length === 0) return null;

  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{ color: COLORS.muted, fontSize: 12, marginBottom: 8 }}>{t('cloud.ioTelemetry')}</div>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        pagination={{ pageSize: 5, showSizeChanger: false }}
        scroll={{ x: 1200 }}
        style={{ background: 'transparent' }}
        expandable={{ expandedRowRender, defaultExpandedRowKeys: [] }}
      />
    </div>
  );
};

export default IoTable;
